<template>
  <MenuItem
    v-if="isKDUContract && tender.tenderStatus.id == statuseKeys.COMPLETED"
    class="h11-links"
    data-qa="generate-contract"
    :disabled="loading"
    icon="add-file"
    :label="$t('Tenders.FormContract')"
    @click="createContract"/>
</template>
<script>
import MenuItem from 'components/common/MenuItem.vue'
import contractingMixin from 'mixins/contractingMixin'

export default {
  name: 'createContract',
  mixins: [ contractingMixin ],
  data() {
    return {
      loading: false
    }
  },
  props: {
    tender: {
      type: Object,
      required: true
    }
  },
  computed: {
    isKDUContract() {
      return this.$can('access', 'contracting')
    }
  },
  methods: {
    async createContract() {
      await this.createContractAsync(this.tender.tenderId, [])
    },
  },
  components: {
    MenuItem
  }
}
</script>
